import { TableComponent } from "../../components/users/TableComponent.tsx";

export default function UsersPage() {
  return (
    <div className="w-full h-full p-14">
      <TableComponent />
    </div>
  );
}
